import ForensicSearchPanel from "../../components/enterprise/ForensicSearchPanel";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { platformMockService } from "../../services/mock/platformMockService";
import { intelligenceTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const ForensicSearchPage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  return (
    <ModuleLayout title={t("platform.pages.forensic.title")} subtitle={t("platform.pages.forensic.subtitle")} breadcrumbs={[t("platform.nav.intelligence"), t("platform.tabs.forensicSearch")]} tabs={intelligenceTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <ForensicSearchPanel results={platformMockService.getForensicResults()} dataMode={{ mode: "mock" }} />
      ) : (
        <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledAnalyticsDescription")} />
      )}
    </ModuleLayout>
  );
};

export default ForensicSearchPage;
